import { REFRIGERANT_TYPES_CRUD_ACTION_CREATORS } from '../actions/refrigerant_types_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

/**
 * Global reference data — readable by everyone, writable by nobody, seeded by SQL. Keyed by the
 * refrigerant's designation (`R-404A`) rather than a numeric id.
 *
 * Callers MUST pass `no_pagination: true`: the list endpoint defaults `limit` to 10 and there are
 * more types than that, so a paginated picker would silently truncate and a user would be unable to
 * find their refrigerant.
 */
export const refrigerantTypesRestCrudThunksForBuyer = new RestCrudThunks(
	'refrigerant_types',
	'refrigerant_type',
	'refrigerantType',
	'refrigerantTypes',
	REFRIGERANT_TYPES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'asset/'
);

export const refrigerantTypesRestCrudThunksForSupplier = new RestCrudThunks(
	'refrigerant_types',
	'refrigerant_type',
	'refrigerantType',
	'refrigerantTypes',
	REFRIGERANT_TYPES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'asset/'
);

/** For components shared by both personas. Buyer-defaulting, like every other thunk factory here. */
export const refrigerantTypesRestCrudThunks = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? refrigerantTypesRestCrudThunksForSupplier
		: refrigerantTypesRestCrudThunksForBuyer;
